import React, { useEffect, useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

// const isValidEmail = (email) => {
//   if (!email) return true;
//   return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
// };

const FilterModal = ({ filterModal, setFilterModal, handleExportAll }) => {
  const [data, setData] = useState({
    fromDate: "",
    toDate: "",
  });

  const [downloading, setDownloading] = useState(false);

  const handleFilter = async () => {
    if (data.fromDate && data.toDate && data.fromDate > data.toDate) {
      toast.error("From date cannot be after To date");
      return;
    }
    setDownloading(true);
    try {
      handleExportAll(data.fromDate , data.toDate);
    } catch (err) {
      console.error(err);
      toast.error("Failed to download report");
    } finally {
      setDownloading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <Drawer
      anchor="right"
      open={filterModal}
      onClose={() => setFilterModal(false)}
    >
      <Box sx={{ width: 320, p: 2 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6">Filter Sellers</Typography>
          <IconButton onClick={() => setFilterModal(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* From Date */}
        <Box mb={3}>
          <Typography mb={1}>From Date</Typography>
          <input
            type="date"
            className="form-control"
            value={data.fromDate}
             max={today}
            onChange={(e) => setData({ ...data, fromDate: e.target.value })}
          />
        </Box>

        {/* To Date */}
        <Box mb={3}>
          <Typography mb={1}>To Date</Typography>
          <input
            type="date"
            className="form-control"
            value={data.toDate}
             max={today}
            onChange={(e) => setData({ ...data, toDate: e.target.value })}
          />
        </Box>

        {/* Footer */}
        <Button
          variant="contained"
          fullWidth
          //   onClick={() => {
          //     applyFilter();
          //     setFilterModal(false);
          //   }}
          sx={{ textTransform: "none" }}
          onClick={handleFilter}
          disabled={downloading}
        >
          {downloading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2"></span>
              Downloading...
            </>
          ) : (
            "Download Report"
          )}
        </Button>
      </Box>
    </Drawer>
  );
};

export default FilterModal;
